export const environment = {
    production: true,
    runLocally: false,
    localRedirectUrl: 'http://localhost:4200/',
    redirectUrl: '',
    voteScorecardApiUrl: 'https://ibewapp.org/VoteScorecard2Api/api/v1',
    appVersion: 'v2.1.0',
  };
  